import { fetch } from 'utils';

onLoad();

export function onLoad(context = document) {
    context.addEventListener('change', async e => {
        // Try to get the child element.
        const element = context.querySelector(`[data-cascading-drop-down-list-parent-id="${e.target.id}"]`);

        // Make sure the element exists.
        if (!element)
            return;

        // Make sure the url has been set.
        if (!element.dataset.cascadingDropDownListUrl)
            throw 'You must set the cascading drop down list url.';

        // Reset the value of the child element and trigger the change event.
        element.value = '';
        element.dispatchEvent(new Event('change', { bubbles: true }));

        // Remove the existing options.
        for (let i = element.options.length - 1; i >= 1; i--) {
            element.remove(i);
        }

        // Add the new options (if applicable).
        if (e.target.value.length) {
            const response = await fetch(element.dataset.cascadingDropDownListUrl.format(e.target.value));
            const selectOptions = await response.json();

            for (let i = 0; i < selectOptions.length; i++) {
                const option = document.createElement('option');
                option.textContent = selectOptions[i].text;
                option.value = selectOptions[i].value;
                element.appendChild(option);
            }
        }
    });
}